import { render, staticRenderFns } from "./layoutB.vue?vue&type=template&id=33ffb366"
import script from "./layoutB.vue?vue&type=script&lang=js"
export * from "./layoutB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports